import { render, staticRenderFns } from "./ReportLoan.vue?vue&type=template&id=3270bd9d"
import script from "./ReportLoan.vue?vue&type=script&lang=js"
export * from "./ReportLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports